import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../data/mock';

const StudioHire = () => {
  const studioService = services[0];

  return (
    <div className="bg-black text-white min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="font-display text-5xl md:text-6xl font-bold text-red-500 mb-6 uppercase">
            Studio Hire
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed">
            {studioService.description}
          </p>
        </div>

        {/* Features */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Studio Features</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {studioService.features.map((feature, index) => (
              <div key={index} className="flex items-start gap-4 bg-zinc-900 rounded-lg p-6 border border-red-900/20">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600/10 flex items-center justify-center">
                  <Check className="text-red-500" size={20} />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white mb-2">{feature}</h3>
                  <p className="text-gray-400 text-sm">Professional equipment and support for your production needs</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Pricing */}
        <div className="max-w-4xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Pricing Packages</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {studioService.pricing.map((pkg, index) => (
              <div 
                key={index} 
                className="bg-zinc-900 rounded-lg p-8 border border-red-900/20 hover:border-red-600/50 transition-all text-center"
              >
                <h3 className="text-xl font-semibold text-white mb-2">{pkg.package}</h3>
                <p className="text-4xl font-bold text-red-500 my-6">{pkg.price}</p>
                <Link 
                  to="/contact"
                  className="block w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-full font-mono text-sm tracking-widest uppercase transition-all"
                >
                  Book Now
                </Link>
              </div>
            ))}
          </div>
        </div>

        {/* Image Gallery */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Studio Spaces</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <img 
              src="https://images.unsplash.com/photo-1716703433576-13ff2922db95" 
              alt="Studio interior"
              className="w-full h-80 object-cover rounded-lg"
            />
            <img 
              src="https://images.unsplash.com/photo-1688539688879-e304cb328663" 
              alt="Studio setup"
              className="w-full h-80 object-cover rounded-lg"
            />
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <h2 className="text-3xl font-semibold text-white mb-4">Ready to Book?</h2>
          <p className="text-gray-400 mb-8">Contact us to discuss your project requirements</p>
          <Link 
            to="/contact"
            className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full font-mono text-sm tracking-widest uppercase transition-all"
          >
            Get in Touch
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StudioHire;